var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnrelatedItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20.573 10.372h8.624M20.573 21.846h13.443M20.573 33.321h13.443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.173 13.396L8.126 7.349M14.173 7.349l-6.047 6.047M14.173 24.87l-6.047-6.047M14.173 18.823L8.126 24.87M14.173 36.344l-6.047-6.047M14.173 30.297l-6.047 6.047"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 34.016,
    cy: 10.372,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnrelatedItems);
export default __webpack_public_path__ + "static/media/unrelatedItems.124e45e77f1f8ea6ae8d5735280f2ee7.svg";
export { ForwardRef as ReactComponent };